import { Injectable } from '@angular/core';
import { RequestConfigImplementation, REQUEST_METHODS, HTTPWrapperContext, XHR_STRATEGIES } from '@ptl/xhr';
import { DrugAutoCompleteItem } from 'src/app/shared/interfaces/drug-autocomplete-item.interface';
import { DrugItem } from 'src/app/shared/interfaces/drug-item.interface';
import { HttpHeaders } from '@angular/common/http';
import { DrugDosage } from 'src/app/shared/interfaces/drug-dosage.interface';
import { DOSAGE_FREQUENCIES_ENUM } from 'src/app/shared/enums/dosage-frequency.enum';
import { Package } from 'src/app/shared/interfaces/drug-dosage-package.interface';
import { DecimalPipe } from '@angular/common';
import { BrandingConfigurationService } from '@ptl/brand';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DrugLookupService {
  constructor(
    private decimalPipe: DecimalPipe,
    private httpClient: HTTPWrapperContext,
    private brandService: BrandingConfigurationService
  ) { }

  byName(
    searchString: string,
    take: number = 10
  ): Promise<Array<DrugAutoCompleteItem>> {

    const requestConfigImplementation = new RequestConfigImplementation({
      method: REQUEST_METHODS.GET,
      url: `${environment.infrastructure.connecture.lookupUrlPath}/Drugs/Autocomplete`,
      headers: new HttpHeaders({
        ddToken: this.brandService.getCurrentBrand().ddToken_encoded(),
        ClientID: 'Highmark'
      }),
      GET_PAYLOAD: {
        q: searchString,
        Take: take.toString()
      }
    });
    
    let strategy = environment.infrastructure.connecture.httpStrategy || XHR_STRATEGIES.AXWAY_PRE_PASS;
    this.httpClient.setStrategy(strategy);
    return this.httpClient.makeRequest<Array<DrugAutoCompleteItem>>(requestConfigImplementation);
  }

  byId(drugId: number): Promise<DrugItem> {

    const requestConfigImplementation = new RequestConfigImplementation({
      method: REQUEST_METHODS.GET,
      url: `${environment.infrastructure.connecture.lookupUrlPath}/Drugs/${drugId}`,
      headers: new HttpHeaders({
        ddToken: this.brandService.getCurrentBrand().ddToken_encoded(),
        ClientID: 'Highmark'
      })
    });
    
    let strategy = environment.infrastructure.connecture.httpStrategy || XHR_STRATEGIES.AXWAY_PRE_PASS;
    this.httpClient.setStrategy(strategy);
    return this.httpClient.makeRequest<DrugItem>(requestConfigImplementation);
  }

  getCalculatedDosageQuantityPerMonth(
    dosageOptions: DrugDosage[],
    dosageId: string,
    packageId: string,
    dosageQuantity: number,
    frequency: DOSAGE_FREQUENCIES_ENUM
  ): any {
    const selectedDosage: DrugDosage = dosageOptions.filter(
      dose => dose.DosageID === dosageId
    )[0];
    const selectedPackage: Package = selectedDosage.Packages
      ? selectedDosage.Packages.filter(
          packageItem => packageItem.ReferenceNDC === packageId
        )[0]
      : null;

    let divisor = 1;
    switch (frequency) {
      case DOSAGE_FREQUENCIES_ENUM.EVERY_1_MONTH:
        divisor = 1;
        break;
      case DOSAGE_FREQUENCIES_ENUM.EVERY_2_MONTHS:
        divisor = 2;
        break;
      case DOSAGE_FREQUENCIES_ENUM.EVERY_3_MONTHS:
        divisor = 3;
        break;
    }

    const frequencyPerMonth = selectedPackage
      ? (Number(selectedPackage.PackageQuantity) * Number(dosageQuantity)) /
        divisor
      : Number(dosageQuantity) / divisor;

    if (frequencyPerMonth) {
      return `${this.decimalPipe.transform(frequencyPerMonth, '1.0-2')}`;
    }
  }
}
